// extracted by mini-css-extract-plugin
var _1 = "DemoWrapper_center__f5715";
var _2 = "DemoWrapper_full__79274";
export { _1 as "center", _2 as "full" }
